import { render, staticRenderFns } from "./DepartmentsPanel.vue?vue&type=template&id=d858ebd6&scoped=true&"
import script from "./DepartmentsPanel.vue?vue&type=script&lang=ts&"
export * from "./DepartmentsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentsPanel.vue?vue&type=style&index=0&id=d858ebd6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d858ebd6",
  null
  
)

export default component.exports